import BaseService from '@/scripts/services/base/base.service'

export default class PersonService extends BaseService {
    constructor() {
        super('Person')
    }

    countAgents(filters) {
        return this.postRequest('CountAgents', filters)
    }

    listAgents(filters){
        return this.postRequest('ListAllAgents', filters)
    }

    updateAgentStatus(agentId){
        return this.getRequest('UpdateAgentStatus', { agentId })
    }
}
